// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__Dxh6D","search--group":"styles_search--group__1yvMf","search--input":"styles_search--input__3xuNZ","search--icon":"styles_search--icon__g9PqN"};